import { useState } from "react";
import PhotoUploadBox from "../photoUploadBox/PhotoUploadBox";
import { Container } from "./PhotoUploadGroupStyles";

const PhotoUploadGroup = () => {
  const [files, setFiles] = useState<(File | null)[]>([null, null, null]);
  const [previews, setPreviews] = useState<(string | null)[]>([
    null,
    null,
    null,
  ]);

  const handleImageChange = (index: number, file: File | null) => {
    const updatedFiles = [...files];
    const updatedPreviews = [...previews];

    if (file) {
      updatedFiles[index] = file;

      const reader = new FileReader();
      reader.onloadend = () => {
        updatedPreviews[index] = reader.result as string;
        setFiles(updatedFiles);
        setPreviews(updatedPreviews);
      };
      reader.readAsDataURL(file);
    } else {
      updatedFiles[index] = null;
      updatedPreviews[index] = null;
      setFiles(updatedFiles);
      setPreviews(updatedPreviews);
    }
  };

  return (
    <Container>
      {["Foto de perfil", "Foto secundária 1", "Foto secundária 2"].map(
        (label, index) => (
          <PhotoUploadBox
            key={index}
            label={label}
            index={index}
            preview={previews[index]}
            onChange={handleImageChange}
          />
        )
      )}
    </Container>
  );
};

export default PhotoUploadGroup;
